import React from "react";
import { ELightPath, PlateTypeCaptureProfile } from "../../../Model/CaptureProfile";
import { LightPathCapability } from "../../../Model/ImagerCapabilities";
import FluorescenceExposureOptions from "./FluorescenceExposureOptions";
import FluorescenceOpticOptions from "./FluorescenceOpticOptions";
import UltravioletOpticAndExposureOptions from "./UltravioletOpticAndExposure";
import VisibleOpticAndExposureOptions from "./VisibleOpticAndExposure";

type Props = {
  lightPath: ELightPath;
  lightpathCapability: LightPathCapability;
  style?: React.CSSProperties;
  captureProfile: PlateTypeCaptureProfile;
  setCaptureProfile: (captureProfile: PlateTypeCaptureProfile) => void;
  onErrorOccur: (key: string) => void;
  onErrorCleared: (key: string) => void;
};

export default function OpticsAndExposure({
  lightPath,
  lightpathCapability,
  captureProfile,
  setCaptureProfile,
  style = {},
  onErrorOccur,
  onErrorCleared,
}: Props) {
  return (
    <div
      style={{
        overflow: "auto",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        ...style,
      }}
    >
      {lightPath === ELightPath.Visible && (
        <VisibleOpticAndExposureOptions
          lightpathCapabilities={lightpathCapability}
          captureProfile={captureProfile}
          setCaptureProfile={setCaptureProfile}
          onErrorOccur={onErrorOccur}
          onErrorCleared={onErrorCleared}
        />
      )}

      {lightPath === ELightPath.Ultraviolet && (
        <UltravioletOpticAndExposureOptions
          lightpathCapabilities={lightpathCapability}
          captureProfile={captureProfile}
          setCaptureProfile={setCaptureProfile}
          onErrorOccur={onErrorOccur}
          onErrorCleared={onErrorCleared}
        />
      )}

      {lightPath === ELightPath.Fluorescence && (
        <>
          <FluorescenceOpticOptions
            style={{}}
            lightpathCapability={lightpathCapability}
            captureProfile={captureProfile}
            setCaptureProfile={setCaptureProfile}
            onErrorCleared={onErrorCleared}
            onErrorOccur={onErrorOccur}
          />
          <FluorescenceExposureOptions
            style={{}}
            lightpathCapability={lightpathCapability}
            captureProfile={captureProfile}
            setCaptureProfile={setCaptureProfile}
            onErrorCleared={onErrorCleared}
            onErrorOccur={onErrorOccur}
          />
        </>
      )}
    </div>
  );
}
